import AssistanceTable from './AssistanceTable';

export default AssistanceTable;
